import { mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon, IconGlyph, Typography, useBreakpoints } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0 ${space('primitives_space_24')};
  gap: ${space('primitives_space_8')};

  &:not(:last-child) {
    border-right: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    flex-direction: row;
    padding: unset;

    &:not(:last-child) {
      border-right: unset;
    }
  }
`

const ScoreLabel = styled.div`
  display: flex;
  gap: ${space('primitives_space_8')};
  white-space: nowrap;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    white-space: unset;
  }
`

interface CategoryProps {
  icon: IconGlyph
  score?: number
  label: string
}

export function Category({ icon, score, label }: CategoryProps) {
  const { isDesktop } = useBreakpoints()

  return (
    <Wrapper>
      <Icon glyph={icon} size={isDesktop ? 16 : 32} />
      <ScoreLabel>
        <Typography $variant="body-m-regular-tight">{label}</Typography>
        <Typography $variant="body-m-bold-snug">{score?.toFixed(1)}</Typography>
      </ScoreLabel>
    </Wrapper>
  )
}
